var _defs, _line, _line2, _line3, _line4, _line5, _line6, _polygon, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _polygon2, _rect, _polyline, _polyline2, _line19, _line20, _polyline3, _line21, _polyline4, _line22, _line23, _line24, _polyline5, _polyline6, _polyline7, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _polyline8, _line34, _polyline9, _line35, _line36, _line37, _line38, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _line39, _line40, _line41, _line42, _line43, _line44, _polyline10, _line45, _text17, _text18, _polyline11, _g, _g2, _polyline12, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _text19, _polygon3, _text20, _text21, _text22, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloor3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1854.37 1589.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#6d6d6d;stroke-width:5px;}.cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke-miterlimit:10;}.cls-5{fill:#84bd00;}.cls-6{letter-spacing:-.1em;}.cls-7{font-size:20px;}.cls-7,.cls-8,.cls-9{font-family:Mundial-Thin, Mundial;font-weight:200;}.cls-10{letter-spacing:0em;}.cls-11{letter-spacing:0em;}.cls-8{font-size:10px;}.cls-12{letter-spacing:-.02em;}.cls-13{letter-spacing:-.1em;}.cls-9{font-size:9px;}.cls-2{stroke-dasharray:0 0 12.94 12.94;}.cls-2,.cls-3,.cls-4{stroke:#84bd00;}.cls-3{stroke-dasharray:0 0 12.1 12.1;}.cls-14{letter-spacing:-.02em;}.cls-15{letter-spacing:-.01em;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 873.84,
    y1: 821.22,
    x2: 827.97,
    y2: 821.22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 873.84,
    y1: 825.2,
    x2: 827.97,
    y2: 825.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 926.58,
    y1: 821.22,
    x2: 880.06,
    y2: 821.22
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 926.58,
    y1: 825.2,
    x2: 880.06,
    y2: 825.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 758.8,
    y1: 986.16,
    x2: 731.36,
    y2: 986.16
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 758.8,
    y1: 990.13,
    x2: 731.36,
    y2: 990.13
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "284.54 551.75 222.78 1413.19 711.35 1460.58 1625.16 1463.79 1638.75 1250.2 1102.15 43.95 770.69 92.62 222.78 114.23 284.54 551.75"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 706.13,
    y1: 821.22,
    x2: 671.56,
    y2: 821.22
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 706.13,
    y1: 825.23,
    x2: 671.56,
    y2: 825.23
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 754.27,
    y1: 821.22,
    x2: 718.29,
    y2: 821.22
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 754.27,
    y1: 825.2,
    x2: 718.29,
    y2: 825.2
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 667.08,
    y1: 924.68,
    x2: 667.08,
    y2: 962.09
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 671.06,
    y1: 924.68,
    x2: 671.06,
    y2: 962.09
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 854.97,
    y1: 990.14,
    x2: 896.15,
    y2: 990.14
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 854.97,
    y1: 986.15,
    x2: 896.15,
    y2: 986.15
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 993.66,
    y1: 900.2,
    x2: 1020.69,
    y2: 900.25
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 993.67,
    y1: 896.17,
    x2: 1020.7,
    y2: 896.22
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1033.26,
    y1: 857.23,
    x2: 1033.26,
    y2: 828.88
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1029.27,
    y1: 857.23,
    x2: 1029.27,
    y2: 828.88
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1051.19 118.24 770.68 94.36 271.59 160.12 286.02 544.14 280.46 818.31 272.08 1341.96 711.42 1458.52 1596.24 1284.91 1570.36 1125.19 1428.23 1124.02 1426.81 820.66 1051.19 118.24"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1579.48,
    y: 1285.5,
    width: 8.95,
    height: 2.91,
    transform: "translate(621.58 3086.67) rotate(-100.96)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "509.6 824.2 509.6 988.14 623.65 988.14"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "623.37 830.16 623.37 822.62 507.1 822.59"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 623.37,
    y1: 990.65,
    x2: 623.37,
    y2: 858.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 758.71,
    y1: 988.14,
    x2: 856,
    y2: 988.14
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "669.07 962.09 669.07 988.14 731.36 988.14"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 669.07,
    y1: 820.71,
    x2: 669.07,
    y2: 924.68
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "705 823.22 718.96 823.22 718.96 986.16"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 667.69,
    y1: 879.78,
    x2: 718.71,
    y2: 879.78
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 658.81,
    y1: 899.85,
    x2: 770.14,
    y2: 899.85
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 767.71,
    y1: 821.44,
    x2: 767.71,
    y2: 989.13
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "768.85 930.25 984.39 930.25 984.39 988.14 896.16 988.14"
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "925.07 830.16 925.07 823.22 984.39 823.22 984.39 934.28"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "754.27 823.22 825.48 823.22 825.48 830.16"
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 873.86,
    y1: 823.22,
    x2: 880.07,
    y2: 823.22
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 876.97,
    y1: 860.85,
    x2: 876.97,
    y2: 929.63
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 849.13,
    y1: 980.92,
    x2: 849.13,
    y2: 989.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 850.1,
    y1: 932.41,
    x2: 850.1,
    y2: 956.44
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 901.95,
    y1: 980.92,
    x2: 901.95,
    y2: 990.14
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 902.02,
    y1: 933.32,
    x2: 902.02,
    y2: 957.35
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 862.79,
    y1: 861.19,
    x2: 891.76,
    y2: 861.19
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 985.34,
    y1: 898.21,
    x2: 993.67,
    y2: 898.21
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1020.7,
    y1: 898.21,
    x2: 1031.12,
    y2: 898.21
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1031.27 855.59 1031.27 988.85 1122.15 988.85 1122.15 824.5"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 529.56,
    y1: 824.22,
    x2: 529.56,
    y2: 988.43
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1143.64 824.5 1031.27 824.5 1031.27 828.88"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1123.76,
    y1: 988.85,
    x2: 1143.65,
    y2: 988.85
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1141.13,
    y1: 826.69,
    x2: 1141.13,
    y2: 988.85
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 625.35,
    y1: 858.5,
    x2: 625.35,
    y2: 830.16
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 621.37,
    y1: 858.5,
    x2: 621.37,
    y2: 830.16
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(798.49 1222.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B\xFC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 24.53,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.46,
    y: 0
  }, "o"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(580.25 942.33) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 9.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.02,
    y: 0
  }, "eppen"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1083.34 942.33) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 9.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.02,
    y: 0
  }, "eppen"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(676.88 937.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.51,
    y: 0
  }, "echnik"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 5.22,
    y: 12
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.73,
    y: 12
  }, "aum"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(678.08 859.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lift"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(727.52 871.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lift"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(804.42 886.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(787.75 909.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Hee"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 37.39,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.33,
    y: 0
  }, "en"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(914.17 886.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(897.65 909.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Damen"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(687.71 372.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B\xFC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 24.53,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.46,
    y: 0
  }, "o"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(927.37 968.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(790.37 968.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(676.56 893.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(1134.12 914.71) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(522.81 918.7) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 631.34,
    y1: 899.85,
    x2: 623.65,
    y2: 899.85
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 658.78,
    y1: 897.86,
    x2: 631.34,
    y2: 897.86
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 658.78,
    y1: 901.84,
    x2: 631.34,
    y2: 901.84
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 559.1,
    y1: 800.08,
    x2: 569.7,
    y2: 823.22
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 601.81,
    y1: 588.22,
    x2: 624.48,
    y2: 588.22
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 793.72,
    y1: 588.15,
    x2: 831.25,
    y2: 588.15
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "959.71 588.09 984.65 588.09 988.87 598.9"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1031.27,
    y1: 804.32,
    x2: 1031.27,
    y2: 824.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(713.32 696.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.7,
    y: 0
  }, "trium"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(747.37 791.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Gang"))), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "559.1 800.08 514.97 702 564.2 588.15 601.81 588.15"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 624.48,
    y1: 588.22,
    x2: 630.48,
    y2: 588.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 642.57,
    y1: 588.21,
    x2: 781.67,
    y2: 588.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 787.72,
    y1: 588.15,
    x2: 793.72,
    y2: 588.15
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 831.25,
    y1: 588.22,
    x2: 837.25,
    y2: 588.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 850.19,
    y1: 588.21,
    x2: 947.24,
    y2: 588.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 953.71,
    y1: 588.15,
    x2: 959.71,
    y2: 588.15
  }))), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "988.87 598.9 1031.3 706.9 1031.27 804.32"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1355.13,
    y: 693.41,
    width: 8.95,
    height: 2.91,
    transform: "translate(-165.28 772.9) rotate(-30)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1590.52,
    y: 1279.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-214.34 326.55) rotate(-10.96)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 267.79,
    y: 171.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-7.44 12.32) rotate(-2.56)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.32,
    y: 158.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(425.02 -124.88) rotate(87.44)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 295.32,
    y: 155.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(443.04 -149.72) rotate(87.44)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 317.32,
    y: 152.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(461.06 -174.57) rotate(87.44)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 339.32,
    y: 149.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(479.08 -199.41) rotate(87.44)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 361.32,
    y: 146.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(497.1 -224.26) rotate(87.44)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 383.32,
    y: 143.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(515.13 -249.1) rotate(87.44)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 405.32,
    y: 140.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(533.15 -273.95) rotate(87.44)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 428.32,
    y: 137.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(552.12 -299.79) rotate(87.44)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 449.32,
    y: 134.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(569.19 -323.63) rotate(87.44)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 472.32,
    y: 131.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(588.17 -349.48) rotate(87.44)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 493.32,
    y: 128.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(605.23 -373.32) rotate(87.44)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 515.32,
    y: 126.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(624.25 -397.21) rotate(87.44)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 537.32,
    y: 123.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(642.27 -422.06) rotate(87.44)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 560.32,
    y: 120.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(661.25 -447.9) rotate(87.44)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 582.32,
    y: 117.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(679.27 -472.74) rotate(87.44)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 604.32,
    y: 114.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(697.29 -497.59) rotate(87.44)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 626.32,
    y: 111.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(715.31 -522.43) rotate(87.44)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 648.32,
    y: 108.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(733.33 -547.28) rotate(87.44)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 670.32,
    y: 105.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(751.36 -572.12) rotate(87.44)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 692.32,
    y: 102.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(769.38 -596.96) rotate(87.44)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 714.32,
    y: 99.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(787.4 -621.81) rotate(87.44)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 737.32,
    y: 97.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(807.37 -646.7) rotate(87.44)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 757.32,
    y: 94.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(823.48 -669.54) rotate(87.44)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.79,
    y: 194.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-8.46 12.39) rotate(-2.56)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 269.79,
    y: 216.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-9.44 12.46) rotate(-2.56)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 270.79,
    y: 238.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-10.42 12.52) rotate(-2.56)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 270.79,
    y: 261.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-11.45 12.55) rotate(-2.56)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 271.79,
    y: 283.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-12.43 12.61) rotate(-2.56)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 272.79,
    y: 305.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-13.41 12.68) rotate(-2.56)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.79,
    y: 327.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-14.39 12.75) rotate(-2.56)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 274.79,
    y: 350.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-15.42 12.81) rotate(-2.56)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.79,
    y: 372.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-16.4 12.88) rotate(-2.56)"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.79,
    y: 394.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-17.38 12.9) rotate(-2.56)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 276.79,
    y: 416.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-18.36 12.97) rotate(-2.56)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 277.79,
    y: 438.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-19.34 13.03) rotate(-2.56)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 278.79,
    y: 461.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-20.37 13.1) rotate(-2.56)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 279.79,
    y: 483.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-21.35 13.17) rotate(-2.56)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 279.79,
    y: 505.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-22.33 13.19) rotate(-2.56)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 280.79,
    y: 527.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-23.31 13.26) rotate(-2.56)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 281.79,
    y: 537.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-23.76 13.31) rotate(-2.56)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.6,
    y: 932.99,
    width: 8.95,
    height: 2.91
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 274.6,
    y: 955.99,
    width: 8.95,
    height: 2.91
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.6,
    y: 977.99,
    width: 8.95,
    height: 2.91
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.6,
    y: 999.99,
    width: 8.95,
    height: 2.91
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 273.6,
    y: 1021.99,
    width: 8.95,
    height: 2.91
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 272.6,
    y: 1044.99,
    width: 8.95,
    height: 2.91
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 272.6,
    y: 1066.99,
    width: 8.95,
    height: 2.91
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 271.6,
    y: 1088.99,
    width: 8.95,
    height: 2.91
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 271.6,
    y: 1111.99,
    width: 8.95,
    height: 2.91
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 271.6,
    y: 1133.99,
    width: 8.95,
    height: 2.91
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 270.6,
    y: 1155.99,
    width: 8.95,
    height: 2.91
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 270.6,
    y: 1177.99,
    width: 8.95,
    height: 2.91
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 269.6,
    y: 1199.99,
    width: 8.95,
    height: 2.91
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 269.6,
    y: 1222.99,
    width: 8.95,
    height: 2.91
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.6,
    y: 1244.99,
    width: 8.95,
    height: 2.91
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.6,
    y: 1266.99,
    width: 8.95,
    height: 2.91
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.6,
    y: 1289.99,
    width: 8.95,
    height: 2.91
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 268.6,
    y: 1311.99,
    width: 8.95,
    height: 2.91
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 267.6,
    y: 1333.99,
    width: 8.95,
    height: 2.91
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 287.6,
    y: 1345.99,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1085.93 1302.54) rotate(-75.9)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 308.6,
    y: 1351.99,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1075.86 1327.45) rotate(-75.9)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 330.6,
    y: 1357.99,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1065.04 1353.32) rotate(-75.9)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 351.77,
    y: 1363.31,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1054.18 1377.88) rotate(-75.9)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 373.81,
    y: 1368.84,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1042.88 1403.43) rotate(-75.9)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 395.02,
    y: 1374.7,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1032.51 1428.44) rotate(-75.9)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 416.24,
    y: 1380.55,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1022.14 1453.45) rotate(-75.9)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 437.83,
    y: 1386.4,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1011.48 1478.81) rotate(-75.9)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 459.04,
    y: 1391.73,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1000.61 1503.41) rotate(-75.9)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 480.84,
    y: 1397.58,
    width: 8.95,
    height: 2.91,
    transform: "translate(-989.79 1528.98) rotate(-75.9)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 502.43,
    y: 1403.36,
    width: 8.95,
    height: 2.91,
    transform: "translate(-979.07 1554.29) rotate(-75.9)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 524.22,
    y: 1408.84,
    width: 8.95,
    height: 2.91,
    transform: "translate(-967.89 1579.57) rotate(-75.9)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 545.51,
    y: 1414.84,
    width: 8.95,
    height: 2.91,
    transform: "translate(-957.61 1604.76) rotate(-75.9)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 566.8,
    y: 1420.69,
    width: 8.95,
    height: 2.91,
    transform: "translate(-947.18 1629.84) rotate(-75.9)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 588.64,
    y: 1426.17,
    width: 8.95,
    height: 2.91,
    transform: "translate(-935.98 1655.17) rotate(-75.9)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 610.01,
    y: 1432.03,
    width: 8.95,
    height: 2.91,
    transform: "translate(-925.49 1680.32) rotate(-75.9)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 631.67,
    y: 1437.95,
    width: 8.95,
    height: 2.91,
    transform: "translate(-914.86 1705.81) rotate(-75.9)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 653.1,
    y: 1443.34,
    width: 8.95,
    height: 2.91,
    transform: "translate(-903.87 1730.66) rotate(-75.9)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 674.68,
    y: 1449.12,
    width: 8.95,
    height: 2.91,
    transform: "translate(-893.14 1755.97) rotate(-75.9)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 696.22,
    y: 1454.52,
    width: 8.95,
    height: 2.91,
    transform: "translate(-882.1 1780.95) rotate(-75.9)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 726.55,
    y: 1453.21,
    width: 8.95,
    height: 2.91,
    transform: "translate(-558.15 2448.89) rotate(-100.96)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 748.36,
    y: 1448.54,
    width: 8.95,
    height: 2.91,
    transform: "translate(-527.61 2464.74) rotate(-100.96)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 770.38,
    y: 1444.28,
    width: 8.95,
    height: 2.91,
    transform: "translate(-497.22 2481.28) rotate(-100.96)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 792.4,
    y: 1439.61,
    width: 8.95,
    height: 2.91,
    transform: "translate(-466.42 2497.34) rotate(-100.96)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 813.97,
    y: 1435.43,
    width: 8.95,
    height: 2.91,
    transform: "translate(-436.65 2513.55) rotate(-100.96)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 836.22,
    y: 1431.12,
    width: 8.95,
    height: 2.91,
    transform: "translate(-405.95 2530.26) rotate(-100.96)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 857.91,
    y: 1427.36,
    width: 8.95,
    height: 2.91,
    transform: "translate(-376.43 2547.08) rotate(-100.96)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 879.72,
    y: 1423.13,
    width: 8.95,
    height: 2.91,
    transform: "translate(-346.34 2563.46) rotate(-100.96)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 901.6,
    y: 1418.46,
    width: 8.95,
    height: 2.91,
    transform: "translate(-315.71 2579.39) rotate(-100.96)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 923.34,
    y: 1414.25,
    width: 8.95,
    height: 2.91,
    transform: "translate(-285.71 2595.72) rotate(-100.96)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 945,
    y: 1409.58,
    width: 8.95,
    height: 2.91,
    transform: "translate(-255.34 2611.42) rotate(-100.96)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 967.05,
    y: 1405.79,
    width: 8.95,
    height: 2.91,
    transform: "translate(-225.37 2628.56) rotate(-100.96)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 988.9,
    y: 1401.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-194.75 2644.41) rotate(-100.96)"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1010.87,
    y: 1397.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-164.9 2661.49) rotate(-100.96)"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1032.71,
    y: 1393.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-134.76 2677.89) rotate(-100.96)"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1076.65,
    y: 1384.11,
    width: 8.95,
    height: 2.91,
    transform: "translate(-73.65 2710.36) rotate(-100.96)"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1098.22,
    y: 1379.93,
    width: 8.95,
    height: 2.91,
    transform: "translate(-43.88 2726.57) rotate(-100.96)"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1119.85,
    y: 1375.74,
    width: 8.95,
    height: 2.91,
    transform: "translate(-14.03 2742.82) rotate(-100.96)"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1141.75,
    y: 1371.5,
    width: 8.95,
    height: 2.91,
    transform: "translate(16.2 2759.28) rotate(-100.96)"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1163.94,
    y: 1367.2,
    width: 8.95,
    height: 2.91,
    transform: "translate(46.83 2775.95) rotate(-100.96)"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1185.55,
    y: 1363.02,
    width: 8.95,
    height: 2.91,
    transform: "translate(76.66 2792.18) rotate(-100.96)"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1207.63,
    y: 1358.75,
    width: 8.95,
    height: 2.91,
    transform: "translate(107.12 2808.77) rotate(-100.96)"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1229.58,
    y: 1354.49,
    width: 8.95,
    height: 2.91,
    transform: "translate(137.42 2825.26) rotate(-100.96)"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1251.26,
    y: 1350.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(167.34 2841.55) rotate(-100.96)"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1273.46,
    y: 1346,
    width: 8.95,
    height: 2.91,
    transform: "translate(197.99 2858.23) rotate(-100.96)"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1295.1,
    y: 1341.81,
    width: 8.95,
    height: 2.91,
    transform: "translate(227.85 2874.49) rotate(-100.96)"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1317.05,
    y: 1337.56,
    width: 8.95,
    height: 2.91,
    transform: "translate(258.15 2890.98) rotate(-100.96)"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1338.82,
    y: 1333.34,
    width: 8.95,
    height: 2.91,
    transform: "translate(288.19 2907.34) rotate(-100.96)"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1360.7,
    y: 1328.67,
    width: 8.95,
    height: 2.91,
    transform: "translate(318.82 2923.26) rotate(-100.96)"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1382.33,
    y: 1324.48,
    width: 8.95,
    height: 2.91,
    transform: "translate(348.67 2939.51) rotate(-100.96)"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1404.53,
    y: 1320.19,
    width: 8.95,
    height: 2.91,
    transform: "translate(379.31 2956.19) rotate(-100.96)"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1426.32,
    y: 1315.97,
    width: 8.95,
    height: 2.91,
    transform: "translate(409.39 2972.56) rotate(-100.96)"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1448.35,
    y: 1311.29,
    width: 8.95,
    height: 2.91,
    transform: "translate(440.19 2988.63) rotate(-100.96)"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1469.86,
    y: 1307.13,
    width: 8.95,
    height: 2.91,
    transform: "translate(469.88 3004.79) rotate(-100.96)"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1491.64,
    y: 1302.91,
    width: 8.95,
    height: 2.91,
    transform: "translate(499.94 3021.15) rotate(-100.96)"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1513.66,
    y: 1298.24,
    width: 8.95,
    height: 2.91,
    transform: "translate(530.74 3037.22) rotate(-100.96)"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1535.69,
    y: 1293.57,
    width: 8.95,
    height: 2.91,
    transform: "translate(561.53 3053.28) rotate(-100.96)"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1557.42,
    y: 1289.77,
    width: 8.95,
    height: 2.91,
    transform: "translate(591.13 3070.09) rotate(-100.96)"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1054.68,
    y: 1388.82,
    width: 8.95,
    height: 2.91,
    transform: "translate(-104.43 2694.4) rotate(-100.96)"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 276.05,
    y: 910.96,
    width: 8.95,
    height: 2.91
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 276.05,
    y: 888.93,
    width: 8.95,
    height: 2.91
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 275.99,
    y: 867.1,
    width: 8.95,
    height: 2.91
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 276.05,
    y: 845.38,
    width: 8.95,
    height: 2.91
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 276.05,
    y: 823.66,
    width: 8.95,
    height: 2.91
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(734.16 937.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Putz"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: -1.95,
    y: 12
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.56,
    y: 12
  }, "aum"))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "886.5 633.56 605.65 656.93 580.15 716.1 608.79 744.7 855.46 744.53 916.1 703.81 886.5 633.56"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(270.21 1391.05) rotate(8.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.01,
    y: 0
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 27.6,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.61,
    y: 0
  }, "asse"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1467.8 998.68) rotate(60.05)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.01,
    y: 0
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 27.6,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.61,
    y: 0
  }, "asse"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1395.58 1398.22) rotate(-7.89)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.01,
    y: 0
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 27.6,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.61,
    y: 0
  }, "asse"))), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1589.02,
    y: 1269.03,
    width: 8.95,
    height: 2.91,
    transform: "translate(-171.55 251.67) rotate(-8.57)"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1585.18,
    y: 1247.35,
    width: 8.95,
    height: 2.91,
    transform: "translate(-168.36 250.86) rotate(-8.57)"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1581.89,
    y: 1225.54,
    width: 8.95,
    height: 2.91,
    transform: "translate(-165.15 250.13) rotate(-8.57)"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1577.99,
    y: 1203.34,
    width: 8.95,
    height: 2.91,
    transform: "translate(-161.88 249.3) rotate(-8.57)"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1574.66,
    y: 1181.25,
    width: 8.95,
    height: 2.91,
    transform: "translate(-158.63 248.55) rotate(-8.57)"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1571.39,
    y: 1159.52,
    width: 8.95,
    height: 2.91,
    transform: "translate(-155.43 247.82) rotate(-8.57)"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1567.51,
    y: 1137.7,
    width: 8.95,
    height: 2.91,
    transform: "translate(-152.22 247) rotate(-8.57)"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1565.64,
    y: 1127.83,
    width: 8.95,
    height: 2.91,
    transform: "translate(-150.77 246.61) rotate(-8.57)"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1551.18,
    y: 1123.65,
    width: 8.95,
    height: 2.91,
    transform: "translate(430.55 2680.77) rotate(-90)"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1529.23,
    y: 1123.65,
    width: 8.95,
    height: 2.91,
    transform: "translate(408.6 2658.82) rotate(-90)"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1506.92,
    y: 1123.65,
    width: 8.95,
    height: 2.91,
    transform: "translate(386.29 2636.51) rotate(-90)"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1484.64,
    y: 1123.33,
    width: 8.95,
    height: 2.91,
    transform: "translate(364.34 2613.9) rotate(-90)"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1462.42,
    y: 1122.82,
    width: 8.95,
    height: 2.91,
    transform: "translate(342.62 2591.17) rotate(-90)"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1440.25,
    y: 1122.82,
    width: 8.95,
    height: 2.91,
    transform: "translate(320.45 2569) rotate(-90)"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1430.97,
    y: 1122.82,
    width: 8.95,
    height: 2.91,
    transform: "translate(311.18 2559.72) rotate(-90)"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1349.93,
    y: 683.51,
    width: 8.95,
    height: 2.91,
    transform: "translate(-163.34 691.04) rotate(-27.06)"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1339.54,
    y: 663.9,
    width: 8.95,
    height: 2.91,
    transform: "translate(-155.56 684.16) rotate(-27.06)"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1328.93,
    y: 644.21,
    width: 8.95,
    height: 2.91,
    transform: "translate(-147.76 677.18) rotate(-27.06)"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1318.17,
    y: 624.38,
    width: 8.95,
    height: 2.91,
    transform: "translate(-139.92 670.12) rotate(-27.06)"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1307.63,
    y: 605.14,
    width: 8.95,
    height: 2.91,
    transform: "translate(-132.32 663.22) rotate(-27.06)"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1297.17,
    y: 585.31,
    width: 8.95,
    height: 2.91,
    transform: "translate(-124.45 656.29) rotate(-27.06)"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1286.71,
    y: 565.85,
    width: 8.95,
    height: 2.91,
    transform: "translate(-116.74 649.4) rotate(-27.06)"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1276.5,
    y: 545.85,
    width: 8.95,
    height: 2.91,
    transform: "translate(-108.76 642.57) rotate(-27.06)"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1266,
    y: 526.26,
    width: 8.95,
    height: 2.91,
    transform: "translate(-101 635.65) rotate(-27.06)"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1255.17,
    y: 506.87,
    width: 8.95,
    height: 2.91,
    transform: "translate(-93.36 628.6) rotate(-27.06)"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1244.99,
    y: 486.94,
    width: 8.95,
    height: 2.91,
    transform: "translate(-85.41 621.79) rotate(-27.06)"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1234.61,
    y: 467.36,
    width: 8.95,
    height: 2.91,
    transform: "translate(-77.64 614.93) rotate(-27.06)"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1223.56,
    y: 448.12,
    width: 8.95,
    height: 2.91,
    transform: "translate(-70.1 607.79) rotate(-27.06)"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1213.42,
    y: 428.27,
    width: 8.95,
    height: 2.91,
    transform: "translate(-62.18 601.01) rotate(-27.06)"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1202.93,
    y: 408.75,
    width: 8.95,
    height: 2.91,
    transform: "translate(-54.45 594.1) rotate(-27.06)"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1192.02,
    y: 389.07,
    width: 8.95,
    height: 2.91,
    transform: "translate(-46.69 586.99) rotate(-27.06)"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1181.82,
    y: 369.53,
    width: 8.95,
    height: 2.91,
    transform: "translate(-38.92 580.21) rotate(-27.06)"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1170.95,
    y: 349.77,
    width: 8.95,
    height: 2.91,
    transform: "translate(-31.12 573.1) rotate(-27.06)"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1160.77,
    y: 329.84,
    width: 8.95,
    height: 2.91,
    transform: "translate(-23.17 566.29) rotate(-27.06)"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1149.88,
    y: 310.55,
    width: 8.95,
    height: 2.91,
    transform: "translate(-15.59 559.22) rotate(-27.06)"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1139.34,
    y: 290.94,
    width: 8.95,
    height: 2.91,
    transform: "translate(-7.82 552.29) rotate(-27.06)"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1129.23,
    y: 271.15,
    width: 8.95,
    height: 2.91,
    transform: "translate(.07 545.52) rotate(-27.06)"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1118.49,
    y: 251.51,
    width: 8.95,
    height: 2.91,
    transform: "translate(7.84 538.48) rotate(-27.06)"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1107.8,
    y: 231.68,
    width: 8.95,
    height: 2.91,
    transform: "translate(15.69 531.45) rotate(-27.06)"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1097.76,
    y: 212,
    width: 8.95,
    height: 2.91,
    transform: "translate(23.53 524.73) rotate(-27.06)"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1087.32,
    y: 192.53,
    width: 8.95,
    height: 2.91,
    transform: "translate(31.25 517.85) rotate(-27.06)"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1076.49,
    y: 172.77,
    width: 8.95,
    height: 2.91,
    transform: "translate(39.05 510.76) rotate(-27.06)"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1066.5,
    y: 153.22,
    width: 8.95,
    height: 2.91,
    transform: "translate(46.85 504.08) rotate(-27.06)"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1055.51,
    y: 133.5,
    width: 8.95,
    height: 2.91,
    transform: "translate(54.62 496.92) rotate(-27.06)"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1050.44,
    y: 124.63,
    width: 8.95,
    height: 2.91,
    transform: "translate(58.1 493.64) rotate(-27.06)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor3);
export default __webpack_public_path__ + "static/media/floor3.8b823fe9b662f0d9d622c81a525ec1ae.svg";
export { ForwardRef as ReactComponent };